import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import JobList from "@/pages/JobList";
import JobDetail from "@/pages/JobDetail";
import ListPage from "@/pages/ListPage";
import ItemDetail from "@/pages/ItemDetail";
import { About, Contact, EditorialPolicy, PrivacyPolicy, Disclaimers } from "@/pages/Static";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import SectorsIndex from "@/pages/SectorsIndex";
import SectorHub from "@/pages/SectorHub";
import SalaryCalculatorPage from "@/pages/SalaryCalculatorPage";
import StateJobsPage from "@/pages/StateJobsPage";
import SchemesIndex from "@/pages/SchemesIndex";
import SchemeDetail from "@/pages/SchemeDetail";
import { PyqIndex, PyqDetail } from "@/pages/PyqPages";
import { GuidesIndex, GuideDetail } from "@/pages/FormGuides";
import RankPredictorPage from "@/pages/RankPredictorPage";
import { PrivateJobsIndex, PrivateCompanyDetail, PrivateJobDetail, PrivateCompanySalaries } from "@/pages/PrivateJobs";
import VacancyTrendsPage from "@/pages/VacancyTrendsPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSeoDashboard from "@/pages/AdminSeoDashboard";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout/>}>
              <Route index element={<Home/>}/>
              <Route path="all-india-jobs" element={<JobList pageTitle="All India Jobs" basePath="/all-india-jobs"/>}/>
              <Route path="latest-jobs" element={<JobList pageTitle="Latest Jobs" forceLatest basePath="/latest-jobs"/>}/>
              <Route path="jobs/:slug" element={<JobDetail/>}/>
              <Route path="admit-cards" element={<ListPage kind="admit-cards" title="Admit Cards" subtitle="Latest exam admit cards & hall tickets"/>}/>
              <Route path="admit-cards/:slug" element={<ItemDetail kind="admit-cards" title="Admit Card"/>}/>
              <Route path="results" element={<ListPage kind="results" title="Results" subtitle="Recently declared exam results"/>}/>
              <Route path="results/:slug" element={<ItemDetail kind="results" title="Result"/>}/>
              <Route path="blog" element={<Blog/>}/>
              <Route path="blog/:slug" element={<BlogDetail/>}/>
              <Route path="sectors" element={<SectorsIndex/>}/>
              <Route path="sectors/:slug" element={<SectorHub/>}/>
              <Route path="tools/salary-calculator" element={<SalaryCalculatorPage/>}/>
              <Route path="tools/rank-predictor" element={<RankPredictorPage/>}/>
              <Route path="schemes" element={<SchemesIndex/>}/>
              <Route path="schemes/:slug" element={<SchemeDetail/>}/>
              <Route path="pyq" element={<PyqIndex/>}/>
              <Route path="pyq/:examSlug" element={<PyqDetail/>}/>
              <Route path="guides" element={<GuidesIndex/>}/>
              <Route path="guides/:slug" element={<GuideDetail/>}/>
              <Route path="states/:stateSlug" element={<StateJobsPage/>}/>
              {/* Govt jobs alias — SEO landing */}
              <Route path="govt-jobs" element={<JobList pageTitle="Government Jobs in India 2026" basePath="/govt-jobs"/>}/>
              {/* Private-sector jobs */}
              <Route path="private-jobs" element={<PrivateJobsIndex/>}/>
              <Route path="private-jobs/:companySlug" element={<PrivateCompanyDetail/>}/>
              <Route path="private-jobs/:companySlug/salaries" element={<PrivateCompanySalaries/>}/>
              <Route path="private-jobs/:companySlug/:jobSlug" element={<PrivateJobDetail/>}/>
              <Route path="vacancy-trends" element={<VacancyTrendsPage/>}/>
              <Route path="about" element={<About/>}/>
              <Route path="contact" element={<Contact/>}/>
              <Route path="editorial-policy" element={<EditorialPolicy/>}/>
              <Route path="privacy-policy" element={<PrivacyPolicy/>}/>
              <Route path="disclaimers" element={<Disclaimers/>}/>
              <Route path="admin/login" element={<AdminLogin/>}/>
              <Route path="admin/seo" element={<AdminSeoDashboard/>}/>
              <Route path="admin" element={<AdminDashboard/>}/>
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors/>
      </AuthProvider>
    </div>
  );
}

export default App;
